import { injectCpmsBoTransactionReportsEnergyStatisticsApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-transaction-reports-energy-statistics.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoTransactionReportsEnergyStatisticsApi =
  injectCpmsBoTransactionReportsEnergyStatisticsApi(baseApi);

export const {
  useCpmsBoGetEnergyDeliveredByLocationQuery,
  useCpmsBoGetEnergyDeliveredByThirdPartyEndpointQuery,
  useCpmsBoGetEnergyDeliveredByChargePointQuery,
  useCpmsBoGetEnergyDeliveredByConnectorTypeQuery,
  useCpmsBoGetEnergyDeliveredEnergyByTokenTypeQuery,
  useCpmsBoGetEnergyDeliveredByDayQuery,
  useCpmsBoGetEnergyDeliveredByMonthQuery,
  useCpmsBoGetEnergyDeliveredByYearQuery,
  useCpmsBoGetEnergyDeliveredForecastQuery,
  useCpmsBoGetEnergyDeliveredQuery,
} = cpmsBoTransactionReportsEnergyStatisticsApi;
